import { Trans, useTranslation } from "i18n";
import { SubscriptionTypes } from "component-library";

interface Props {
  fromPlan: SubscriptionTypes;
  priceWithTax: string;
  priceWithoutTax: string;
  subscriptionTimePeriod: string;
}

const ReinstateOriginalPlanModalSubscriptionBatch = ({
  fromPlan,
  priceWithTax,
  priceWithoutTax,
  subscriptionTimePeriod,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 text-white bg-color-brand-two rounded-[5px] flex justify-between items-center">
      <div>
        <p className="text-[22px] leading-[30px] uppercase">{fromPlan}</p>
      </div>
      <div className="flex flex-col items-center justify-center min-w-[200px]">
        <p className="text-[26px]">
          <Trans
            i18nKey="performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.priceWithTax"
            values={{
              priceWithTax,
              subscriptionTimePeriod,
            }}
            components={{
              span: <span className="text-[16px]" />,
            }}
          />
        </p>
        <p className="text-[16px] font-normal">
          {t(
            "performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.priceWithoutTax",
            {
              priceWithoutTax,
            }
          )}
        </p>
      </div>
    </div>
  );
};

export default ReinstateOriginalPlanModalSubscriptionBatch;
